<mat-card>
    <div class="border-left card px-3">
        <div class="my-2 p-0">
            <!-- Menu pour sélectionner le type de graphique -->
            <button type="button" class="btn btn-outline-secondary btn-sm border-0"
                    [matMenuTriggerFor]="cardHeaderMenu">
                Graphique<i class="fa-solid fa-angle-down ms-2"></i>
            </button>
            <!--<button type="button" class="btn btn-outline-secondary btn-sm border-0"
                    [matMenuTriggerFor]="durationMenu">
                Durée<i class="fa-solid fa-angle-down ms-2"></i>
            </button>-->
        </div>
        <div class="charts mb-25 mx-3 row">
            <!-- Graphique Line -->
            <div class="line border col-lg-8" [chart]="lineChart">
            </div>
            <div class="line border col-lg-8" [chart]="lienChart1">
            </div>
        </div>
    </div>
</mat-card>

<!-- Menu pour choisir le type de graphique -->
<mat-menu #cardHeaderMenu="matMenu" class="card-header-menu" xPosition="after">
    <button mat-menu-item (click)="handleChartType(type)" *ngFor="let type of chartTyp; let i = index">
        {{ type.toUpperCase() }}
    </button>
</mat-menu>

<!-- Menu pour choisir la durée -->
<mat-menu #durationMenu="matMenu" class="card-header-menu" xPosition="after">
    <!-- Ajoute ici les options pour la durée -->
</mat-menu>
